export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.b319aaa8.eot";